module.exports = __webpack_public_path__ + "static/media/IBGHPruefung2026.ea713592.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/IBGHPruefung2026.jpg
// module id = 331
// module chunks = 0